import { render, staticRenderFns } from "./NewLeadDetail.vue?vue&type=template&id=f523c87c&scoped=true"
import script from "./NewLeadDetail.vue?vue&type=script&lang=js"
export * from "./NewLeadDetail.vue?vue&type=script&lang=js"
import style0 from "./NewLeadDetail.vue?vue&type=style&index=0&id=f523c87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f523c87c",
  null
  
)

export default component.exports